// extracted by mini-css-extract-plugin
module.exports = {"markdownStyles":"hf_0hc1o"};